import { connect } from 'react-redux';
import { Dispatch , AnyAction } from 'redux';
import { AppState } from '../../redux';
import { onbulkDownload, onBulkDownloadIndividual, onBulkDownloadStl, rowClick } from 'src/actions/completeOrderAction';
import OrderRawDataPage from './OrderRawDataPage';
import { savefromDate, savetoDate, getArchiveData } from 'src/actions/orderRawDataActions';
import { RowDataCompleted } from 'src/reducers/completeorderfile';
import { SHOW_FAILED_FILES_DIALOG } from '../../reducers/completeorderfile';

export const mapStateToProps = (state: AppState) => {
    return {
        orderrawdata: state.completeOrder.orderrawdata,
        orderrawdataExport: state.completeOrder.orderrawdataExport,
        startDate: state.completeOrder.startDateRaw,
        endDate: state.completeOrder.endDateRaw,
        isDownloading: state.completeOrder.isDownloading,
        // New properties for failed files dialog
        failedFiles: state.completeOrder.failedFiles,
        showFailedFilesDialog: state.completeOrder.showFailedFilesDialog,
        failedFilesMessage: state.completeOrder.failedFilesMessage,
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            // dispatch(getArchiveData('get'));
        },
        reload: (fcaseno: string, tcaseno: string, timezone: string) => {
            dispatch(getArchiveData('get', fcaseno, tcaseno, timezone));
        },
        onRowClick: (orderid: string, rowData: string) => {
            dispatch(rowClick(orderid, rowData));
        },
        fDate: (fromDate: Date | null) => {
            dispatch(savefromDate(fromDate));
        },
        toDate: (toDate: Date | null) => {
            dispatch(savetoDate(toDate));
        },
        dateFilter: (fcaseno: string, tcaseno: string, timezone: string) => {
            dispatch(getArchiveData('get', fcaseno, tcaseno, timezone));
        },
        dateReset: (timezone: string) => {
            dispatch(getArchiveData('reset', '', '', timezone));
        },
        onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted) => {
            dispatch(onbulkDownload(completedData, true));
        },
        onBulkDownloadStl: (completedData: RowDataCompleted[] | RowDataCompleted, filetype: string) => {
            dispatch(onBulkDownloadStl(completedData, filetype, true));
        },
        onBulkDownloadIndividual: (completedData: RowDataCompleted[] | RowDataCompleted) => {
            dispatch(onBulkDownloadIndividual(completedData, true));
        },
         closeFailedFilesDialog: () => {
            dispatch({ type: SHOW_FAILED_FILES_DIALOG, showFailedFilesDialog: false } as AnyAction);
        },
    };
};

const OrderRawDataContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(OrderRawDataPage);

export default OrderRawDataContainer;



// WEBPACK FOOTER //
// ./src/components/OrderRawDataPage/OrderRawDataContainer.tsx